module.exports = {"attributes":{"viewBox":"0 0 16 12"},"content":"<g fill=\"none\" fill-rule=\"evenodd\" opacity=\".9\">     <path fill=\"none\" d=\"M0-2h16v16H0z\"/>     <path fill=\"#646464\" d=\"M3.5 4.5h1.3a.8.8 0 0 1 0 1.5H3.5v1.3a.8.8 0 0 1-1.5 0V6H.7a.8.8 0 0 1 0-1.5H2V3.2a.8.8 0 0 1 1.5 0v1.3zM10.2 6a3 3 0 0 1-3-3 3 3 0 0 1 3-3A3 3 0 0 1 13 3a3 3 0 0 1-3 3zm-5.8 4.5c0-2 3.8-3 5.8-3s5.8 1 5.8 3v.5c0 .6-.4 1-1 1H5.4a1 1 0 0 1-1-1v-.5z\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-invite.svg
// module id = 625
// module chunks = 0